import { Component, 
  OnInit, 
  Input, 
  ElementRef, 
  Renderer2, 
  ChangeDetectionStrategy,
  HostListener, 
} from '@angular/core';
import { Question, Option, TableHandler, Cell, ReplyItem } from '../../../../../../classes';
import { RepliesService } from '../../../../../../services';
import { map, tap } from 'rxjs/operators';
import { get, keys } from 'lodash';
import { Observable } from 'rxjs';
import { ChartsService } from '../../../../charts.service';
import { RepliesPerOptionService } from '../../../../modals/replies-per-option/replies-per-option.service';

@Component({
  selector: '[regular-cell]',
  templateUrl: './regular-cell.component.html',
  styleUrls: ['./regular-cell.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class RegularCellComponent implements OnInit {
  @Input() table:TableHandler;
  @Input() cell:Cell;
  get option ():Option {
    return this.cell.option;
  }
  get question ():Question {
    return this.cell.option.question;
  }
  replyList = this.replies.list.pipe(
    map(list=>list.filter(li=>get(li, ['snapshot', this.question.id, this.option.id]))),
    map(list=>{
      return list.map(li=>{
        const parent_question_id:string = this.question.dependency.id;
        let selected_parent_question_option_colors:string[] = [];
        if (parent_question_id) {
          const parent_question:Question = this.question.survey.getQuestions({id:this.question.dependency.id})[0];
          if (parent_question) {
            selected_parent_question_option_colors = 
            keys(
              get(li, ['snapshot', parent_question_id])
            )
            .map(o_id=>parent_question.getOptions({id:o_id})[0])
            .filter(o=>o) // filter out undefined
            .map(o=>this.charts.getColor(o))            
          }                
        } 
        return {...li, selected_parent_question_option_colors:selected_parent_question_option_colors };
      })
    })
  ) as Observable<Array<ReplyItem & {parent_question_selection?:string[]}>>

  constructor(
    private elementRef:ElementRef,
    private renderer:Renderer2,
    private replies:RepliesService,
    private charts:ChartsService,
    private repliesPerOptionModal:RepliesPerOptionService, 
  ) { 
  }
  ngOnInit() {
    this.renderer.addClass(this.elementRef.nativeElement, 'position-relative');
    this.renderer.addClass(this.elementRef.nativeElement, 'ellipsis');
    // this.renderer.addClass(this.elementRef.nativeElement, 'p-0');
    if (this.option.quota === 0) this.renderer.addClass(this.elementRef.nativeElement, 'disabled');      

  }
  getBackground (colors:string[] = []) {
    if (colors.length > 0) return `linear-gradient(${colors.join(', ')})`;
    return null;
  }
  @HostListener('click', []) openModal (bool:boolean = undefined) {
    this.repliesPerOptionModal.open(
      this.option, 
      this.replies.list.pipe(
        map(list=>list.filter(li=>get(li, ['snapshot', this.question.id, this.option.id]))),
      )
    )
  }

}
